import { render, staticRenderFns } from "./vOrderErrors.vue?vue&type=template&id=72d41c80&"
import script from "./vOrderErrors.vue?vue&type=script&lang=js&"
export * from "./vOrderErrors.vue?vue&type=script&lang=js&"
import style0 from "./vOrderErrors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports